import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { withRootStore } from "mrb/core";
import { MrbButton } from "mrb/components";

const IMPERSONATING_BODY_CLASS = "is-impersonating";

const ImpersonationBanner = observer(function ImpersonationBanner({ rootStore }) {
    const { t } = useTranslation();
    const { impersonationStore } = rootStore;
    const isImpersonating = impersonationStore.isImpersonating;

    // Toggle a body-level class so the fixed sidebar can be offset below the
    // banner (the banner overlays it otherwise — see c.layout.css).
    useEffect(() => {
        if (isImpersonating) {
            document.body.classList.add(IMPERSONATING_BODY_CLASS);
        } else {
            document.body.classList.remove(IMPERSONATING_BODY_CLASS);
        }
        return () => document.body.classList.remove(IMPERSONATING_BODY_CLASS);
    }, [isImpersonating]);

    if (!isImpersonating) {
        return null;
    }

    const email = impersonationStore.impersonatedUser
        ? impersonationStore.impersonatedUser.email
        : "";

    return (
        <div className="c-impersonation-banner" role="status">
            <span className="c-impersonation-banner__text">
                {t("ADMINISTRATION.USER.IMPERSONATION.BANNER", { email })}
            </span>
            <MrbButton
                t={t}
                label="ADMINISTRATION.USER.IMPERSONATION.STOP"
                classNameOverride="c-btn c-btn--base c-btn--ghost"
                onClick={() => impersonationStore.stopImpersonation()}
            />
        </div>
    );
});

export default withRootStore(ImpersonationBanner);
